import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useMemo } from "react";

const CustomAutoComplete = ({ listData, ...props }) => {
    const sortedDataList = useMemo(() => {
        if (!listData?.data || !Array.isArray(listData.data)) return [];        
        return [...listData.data].sort((a, b) => {
            const aValue = a.value || '';
            const bValue = b.value || '';
            return aValue.localeCompare(bValue);
        });
    }, [listData]);

    return (
        <>
            <label className="input-label">
                {listData?.label} {listData?.required ? <span className="required-input">*</span> : ""}
            </label>
            <Autocomplete
                {...(props.value ? { value: props.value } : { value: null })}
                onChange={(event, newValue) => {
                    props.handleDataChange(newValue);
                    if (props.onChange) {
                        props.onChange({
                            target: { name: props.name, value: newValue },
                        });
                    }
                }}
                getOptionLabel={option => `${option?.nom_societe !== undefined ? option?.nom_societe + " - " : ""} ${option.value !== undefined ? option.value : option.selectionName}`}
                getOptionSelected={(option, value) => option.id === value.id}
                options={sortedDataList}
                noOptionsText={"Aucune donnée trouvée."}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        variant="outlined"
                        {...(props.errors && props.errors[props?.name] && {
                            error: true,
                            label: props.errors[props.name],
                        })}
                    />
                }
                {...(props.disableClearable ? { disableClearable: props.disableClearable } : { disableClearable: false })}
                loading={listData?.isLoading}
                loadingText="Chargement..."
            />
        </>
    )
}

export default CustomAutoComplete